import { render, staticRenderFns } from "./FeatureAttachements.vue?vue&type=template&id=4a55d9c5"
import script from "./FeatureAttachements.vue?vue&type=script&lang=js"
export * from "./FeatureAttachements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports